import { css, styled } from 'styled-components';

import { Image } from 'app/components/image';
import arrowRightHover from 'app/resources/arrow-right-hover.svg';
import arrowRight from 'app/resources/arrow-right.svg';
import { breakpointTablet } from 'app/style/breakpoints';
import { colorSecondary200, colorSecondary300, colorSecondary900 } from 'app/style/colors';
import { focus } from 'app/style/mixins';
import { spacing1, spacing2 } from 'app/style/spacing';

interface StyledNavigationProps {
    $active: boolean;
}

export const StyledContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledImageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 1 auto;
    max-height: 176px;

    @media (min-width: ${breakpointTablet}) {
        padding: 0 ${spacing2};
        max-height: 284px;
    }
`;

export const StyledImage = styled(Image)`
    max-width: 100%;
    min-width: 0;
    min-height: 0;
    flex: 1 1 auto;
    object-fit: contain;
`;

export const StyledArrowColumn = styled.div`
    flex: 0 0 20px;
`;

export const StyledArrowRight = styled.button`
    height: 20px;
    width: 20px;
    background: url(${arrowRight}) no-repeat center;
    border: 0;

    &:hover {
        background: url(${arrowRightHover}) no-repeat center;
        cursor: pointer;
    }

    ${focus};
`;

export const StyledArrowLeft = styled(StyledArrowRight)`
    transform: rotate(180deg);
`;

export const StyledNavigationRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: ${spacing1};
`;

export const StyledNavigationItem = styled.button<StyledNavigationProps>`
    flex: 1 1 auto;
    cursor: pointer;
    margin-right: ${spacing1};
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: ${colorSecondary200};
    height: 5px;

    &:last-child {
        margin-right: 0;
    }

    &:hover {
        background: ${colorSecondary300};
    }

    ${focus};
    ${({ $active }) => $active && stylesActiveNavigationItem};
`;

const stylesActiveNavigationItem = css`
    background: ${colorSecondary900};

    &:hover {
        background: ${colorSecondary900};
    }
`;
